<template>
  <div>
    <div class="mobile-drawer-static-background" @click.prevent="hideDrawer" v-show="visible" />
    <div class="mobile-drawer" v-if="visible">
      <div class="mobile-drawer-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped>


</style>


<script>
export default {
  name: 'MobileDrawer',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showDrawer() {
      // TODO: Show drawer with animations

      this.visible = true
    },
    hideDrawer() {
      // TODO: Hide drawer

      this.visible = false
    }
  }
}
</script>